import React from 'react';
import { Card, CardBody } from 'reactstrap';
import { useResponseContext } from 'js/engines/CapabilitiesAssessment/ResponseContext';
import Element from '../../Element';

export function StandardQuestionsPage({ page, header }) {
  const { questionMap } = useResponseContext();

  return (
    <Card>
      <CardBody>
        {header}
        {(page.elements ?? []).map((element) => {
          const question = questionMap[element.key];
          return question ? (
            <Element key={element.guid} element={question} />
          ) : null;
        })}
      </CardBody>
    </Card>
  );
}

export default StandardQuestionsPage;
